module.exports = __webpack_public_path__ + "img/ftxus.e8b94264.svg";